export * from './zahlungseingang-entfernt.interface';
